import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=48a150ae&scoped=true&lang=pug&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=48a150ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a150ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48a150ae')) {
      api.createRecord('48a150ae', component.options)
    } else {
      api.reload('48a150ae', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=48a150ae&scoped=true&lang=pug&", function () {
      api.rerender('48a150ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/older_adult/components/Modal.vue"
export default component.exports